import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaCheckDouble, FaLock, FaUserShield, FaBookReader } from 'react-icons/fa';
import './FooterPages.css';

const SafetyTrust = () => {
    return (
        <div className="footer-page-container">
            <div className="footer-page-inner">
                <Link to="/" className="footer-back-btn">
                    <FaArrowLeft /> Back to Home
                </Link>

                <div className="footer-header">
                    <h1 className="footer-title">Safety & Trust</h1>
                    <p className="footer-subtitle">
                        Our commitment to a secure and reliable learning environment.
                    </p>
                </div>

                <div className="footer-grid-section">
                    <div className="footer-glass-card">
                        <div className="card-icon"><FaCheckDouble /></div>
                        <h2 style={{ fontSize: '1.5rem', color: '#f8fafc', marginBottom: '1rem' }}>Rigorous Verification</h2>
                        <p>
                            We take credibility seriously. Every Professor of Practice on our platform undergoes a strict verification process. We validate academic credentials, professional experience, and current employment status. This ensures that institutions and students engage with genuine industry leaders.
                        </p>
                    </div>

                    <div className="footer-glass-card">
                        <div className="card-icon"><FaLock /></div>
                        <h2 style={{ fontSize: '1.5rem', color: '#f8fafc', marginBottom: '1rem' }}>Secure Payments</h2>
                        <p>
                            Financial peace of mind is paramount. We utilize a secure Escrow-based payment system. Funds deposited by institutions are held safely and only released to the professional upon successful completion of the engagement. This protects both parties from fraud and non-delivery.
                        </p>
                    </div>

                    <div className="footer-glass-card">
                        <div className="card-icon"><FaUserShield /></div>
                        <h2 style={{ fontSize: '1.5rem', color: '#f8fafc', marginBottom: '1rem' }}>Data Privacy</h2>
                        <p>
                            Your data is yours. We employ enterprise-grade encryption to protect personal information and institutional data. We are compliant with major data protection regulations and never sell user data to third parties.
                        </p>
                    </div>

                    <div className="footer-glass-card">
                        <div className="card-icon"><FaBookReader /></div>
                        <h2 style={{ fontSize: '1.5rem', color: '#f8fafc', marginBottom: '1rem' }}>Community Guidelines</h2>
                        <p>
                            We foster a respectful and professional community. Our guidelines strictly prohibit harassment, discrimination, and unprofessional conduct. We have a zero-tolerance policy and a dedicated reporting mechanism for any violations.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SafetyTrust;


